<script setup lang="ts">
import { toRefs } from "vue";
import { arrow_left, arrow_right } from "pn-design-assets/pn-assets/icons";
import { computed } from "vue";

const props = defineProps<{
  primaryButtonText: string;
  secondaryButtonText: string;
}>();

const emit = defineEmits<{
  (e: "clickPrimary"): void;
  (e: "clickSecondary"): void;
}>();

const { primaryButtonText, secondaryButtonText } = toRefs(props);

const secondaryButtonClicked = () => {
  emit("clickSecondary");
};

const primaryButtonClicked = () => {
  emit("clickPrimary");
};

const secondaryButtonIcon = computed(() => {
  if (secondaryButtonText.value === "Cancel") {
    return "";
  } else {
    return arrow_left;
  }
});

const primaryButtonIcon = computed(() => {
  if (primaryButtonText.value === "Next") {
    return arrow_right;
  } else {
    return "";
  }
});
</script>

<template>
  <section>
    <div class="buttons">
      <pn-button
        :label="secondaryButtonText"
        appearance="light"
        left-icon="true"
        variant="outlined"
        :icon="secondaryButtonIcon"
        @pnClick="secondaryButtonClicked"
      ></pn-button>
      <pn-button
        :label="primaryButtonText"
        @pnClick="primaryButtonClicked"
        :icon="primaryButtonIcon"
      ></pn-button>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.buttons {
  display: flex;
  padding-top: 24px;
  margin-left: 32px;
  gap: 8px;
  justify-content: flex-start;
}
</style>
